import { CreateReminderRequest } from '@zap-onboard/api-client';
import { Entity } from 'designed';
import { useHandler } from '../../useHandlerMutation';

export const useCreateReminder = (afterSubmit?: () => unknown) => {
  const [create, createIsLoading] = useHandler(
    (api) => api.reminder().createReminder,
    {
      invalidates: () => [['REMINDER_LIST']],
      always: {
        onSuccess: async () => {
          if (afterSubmit) {
            await afterSubmit();
          }
        },
      },
    },
  );

  return {
    create: (data: Entity.Attributes<CreateReminderRequest>) => create(data),
    createIsLoading,
  };
};
